import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const normalize = (p) => (p.length > 1 ? p.replace(/\/+$/, "") : p);
const prerendered = container.dataset.prerendered;

// Hydrate build-time HTML only when it was rendered for this exact URL.
if (prerendered && normalize(prerendered) === normalize(window.location.pathname)) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}
